import { Component } from '@angular/core';

@Component({
  selector: 'ngx-offreskey',
  template: `<router-outlet></router-outlet>`,
})
export class OffresComponent {
}
